// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1c4e7b0d","228":"fdaf8195","268":"d569a940","312":"7f6292e2","433":"3fa4356c","450":"8b8fc8db","551":"d0b41f4f","638":"9187896a","737":"7d078598","842":"ae9d5ac2","965":"7e58f946"}[chunkId] + ".chunk.js";
};